import styled from 'styled-components';

type ChipStyleProps = {
  centered: boolean;
  nocolor: boolean;
};

// Status badge (modern-sea look): a word in a thin outlined box, never colour alone.
export const ChipStyle = styled.div<ChipStyleProps>`
  ${(p) =>
    p.nocolor && !p.color
      ? `
        background: unset !important;
        border: 0 !important;
        padding: 0px 0px 0px 3px !important;
      `
      : `
        padding: 2px 8px;
      `}
  border: 1px solid color-mix(in srgb, currentColor 35%, transparent);
  width: auto;
  max-width: fit-content;
  border-radius: 0;
  background: ${(p) => (p.color ? p.theme.colors.chip[p.color].background : p.theme.colors.general.white)};
  color: ${(p) => (p.color ? p.theme.colors.chip[p.color].color : p.theme.colors.general.textSecondary)};
  font-size: ${(p) => p.theme.font.size.tiny};
  font-weight: ${(p) => p.theme.font.weight.semibold};
  line-height: 18px;
  ${(p) => p.centered && 'margin: auto;'}
  display: inline-flex;
  align-items: center;
  & > span {
    white-space: nowrap;
    overflow: hidden;
  }
`;
